var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42188 11.75L1.88763 13.6138C1.96874 13.9383 2.15599 14.2263 2.41962 14.4322C2.68325 14.6381 3.00813 14.7499 3.34262 14.75H14.5011C14.8356 14.7499 15.1605 14.6381 15.4241 14.4322C15.6878 14.2263 15.875 13.9383 15.9561 13.6138L16.4219 11.75M8.92188 10.25V1.25V10.25ZM8.92188 10.25L5.92188 7.25L8.92188 10.25ZM8.92188 10.25L11.9219 7.25L8.92188 10.25Z",
    stroke: "#133F7D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.4a60d688c0b4c45828dcd421f5db875e.svg";
export { ForwardRef as ReactComponent };